import { Box, Button, TextField } from '@mui/material'
import Header from 'components/Header'
import { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

const DailyOrderSearch = () => {
  const navigate = useNavigate()
  const { company } = useParams()
  const [orderNumber, setOrderNumber] = useState('')

  const handleSubmit = async () => {
    try {
      navigate(`/${company}/daily-order/${orderNumber}`)
    } catch (error) {
      console.error('Error fetching order:', error)
    }
  }

  return (
    <Box sx={{ minHeight: '100vh' }}>
      <Header />
      <Box
        sx={{
          width: '100%',
          maxWidth: 480,
          margin: '40px auto',
          padding: 3,
          backgroundColor: '#ffffff',
          borderRadius: 2,
          boxShadow: '0px 2px 8px rgba(0,0,0,0.1)',
          display: 'flex',
          flexDirection: 'column',
          gap: 3
        }}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            handleSubmit()
          }
        }}
      >
        <TextField
          label='Order Code'
          variant='outlined'
          fullWidth
          value={orderNumber}
          onChange={e => setOrderNumber(e.target.value)}
          autoFocus
        />
        <Button
          variant='contained'
          size='large'
          fullWidth
          onClick={handleSubmit}
          disabled={!orderNumber.trim()}
          sx={{
            background: 'linear-gradient(45deg, #364c63, #5f799a)',
            color: '#fff',
            textTransform: 'none',
            fontSize: '18px',
            fontWeight: 600,
            '&:hover': {
              background: 'linear-gradient(45deg, #4b6485, #758aa8)'
            }
          }}
        >
          Confirm
        </Button>
      </Box>
    </Box>
  )
}

export default DailyOrderSearch
